import React from 'react';
import PropTypes from 'prop-types';
import { Field } from "formik";
import { Checkbox } from "formik-material-ui";
import FormControl from '../components/FormControl.jsx';
import FormGroup from '../components/FormGroup.jsx';
import FormControlLabel from '../components/FormControlLabel.jsx';
import styles from '../styles/styles.js';
import { FormLabel } from '@material-ui/core';
const { makeStyles } = styles;

const FormikCheckbox = props => {
  const classes = useStyles();
  const { disabled, value, name, label } = props;
  const dataTestId = props['data-testid'];
  return (
    <FormControl component={ 'fieldset' }>
      <FormGroup>
        <FormControlLabel
          className={classes.checkbox}
          control={
            <Field
              disabled={ disabled }
              checked={ value }
              data-testid={dataTestId}
              type={props.type || 'checkbox'}
              name={ name }
              label={ label }
              component={ Checkbox }/>
          }
          label={
            <FormLabel className={classes.checkboxLabel} component='legend'>
              {label}
            </FormLabel>
          }/>
      </FormGroup>
    </FormControl>
  );
};

FormikCheckbox.propTypes = {
  disabled: PropTypes.bool,
  value: PropTypes.bool,
  type: PropTypes.oneOf(['checkbox', 'radio', undefined]),
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
};

const useStyles = makeStyles(theme => ({
  select: {
    textAlign: 'left',
  },
  checkboxLabel: {
    color: '#1c1d1f',
  },
}));

export default FormikCheckbox;
